import SyntheseModelesController from './synthesemodeles.controller';

export default {
    template: require('./synthesemodeles.tpl.html'),
    controller: SyntheseModelesController
};
